import { defaultAutolistFetch } from 'lib/AutolistAPI';
import captureException from 'lib/captureException';
import { validateCoordinates } from 'lib/apis/utils';
import qs from 'qs';
import {
  SearchAdInfo,
  SearchParams,
  SearchFacetCounts,
  SearchVehicle,
  SearchResponse,
} from './types';
import { transformAdInfo, transformFacetCounts, transformSrpVehicle } from './transforms';

const SEARCH_V3_PATH = '/api/v3/search';

export interface SearchResult {
  vehicles: SearchVehicle[];
  totalCount: number;
  adInfo: SearchAdInfo | null;
  facetCounts: SearchFacetCounts;
}

function convertResponse(response: SearchResponse): SearchResult {
  return {
    vehicles: response.records.map((vehicle) => transformSrpVehicle(vehicle)),
    totalCount: response.total_count,
    adInfo: transformAdInfo(response.ad_info),
    facetCounts: transformFacetCounts(response.facet_counts),
  };
}

export async function searchVehicles(params: SearchParams): Promise<SearchResult> {
  const validCoordinates = validateCoordinates(params?.latitude, params.longitude);
  if (!validCoordinates) {
    captureException('Valid coordinates were not provided');
    throw Error('Valid coordinates were not provided');
  }

  const { make, model, trim, ...searchParams } = params;
  if (make) {
    searchParams.makes = [make];
    if (model) {
      searchParams.make_models = { [make]: [model] };
      if (trim) {
        searchParams.model_trims = { [model]: trim };
      }
    }
  }

  const queryParams = qs.stringify(searchParams || {}, { arrayFormat: 'brackets', encode: false });
  const query = `ads=true&include_total_price_change=true&include_time_on_market=true&include_relative_price_difference=true&facet_counts=true&${queryParams}`;

  const response: SearchResponse = await defaultAutolistFetch(`${SEARCH_V3_PATH}?${query}`);

  return convertResponse(response);
}

export default {
  searchVehicles,
};
